/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/i18n'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: i18n.t('menu.dashboad.url'),
          name:i18n.t('menu.dashboad.name'),
          component: () => import('./views/Home.vue'),
          meta: {
            breadcrumb: i18n.t('menu.dashboad.meta.breadcrumb'),
            pageTitle: i18n.t('menu.dashboad.meta.pageTitle'),
            rule: i18n.t('menu.dashboad.meta.rule')
          }

        },
        {
          path: '/studentssimple',
          name: 'studentssimple',
          component: () => import('./views/Student.vue')
        },
        {
          path: i18n.t('menu.students.url'),
          name: i18n.t('menu.students.name'),
          component: () => import('@/views/students/DataListView.vue'),
          meta: {
            breadcrumb: i18n.t('menu.students.meta.breadcrumb'),
            pageTitle: i18n.t('menu.students.meta.pageTitle'),
            rule: i18n.t('menu.students.meta.rule')
          }
        },
        {
          path: i18n.t('menu.students_user.url'),
          name: i18n.t('menu.students_user.name'),
          component: () => import('@/views/user-students/DataListView.vue'),
          meta: {
            // breadcrumb: i18n.t('menu.students_user.meta.breadcrumb'),
            pageTitle: i18n.t('menu.students_user.meta.pageTitle'),
            rule: i18n.t('menu.students_user.meta.rule')
          }
        },
        {
          path: i18n.t('menu.students_teacher.url'),
          name: i18n.t('menu.students_teacher.name'),
          component: () => import('@/views/teacher-students/DataListView.vue'),
          meta: {
            breadcrumb: i18n.t('menu.students_teacher.meta.breadcrumb'),
            pageTitle: i18n.t('menu.students_teacher.meta.pageTitle'),
            rule: i18n.t('menu.students_teacher.meta.rule')
          }
        },
        {
          path:  i18n.t('menu.users.url'),
          name:  i18n.t('menu.users.name'),
          component: () => import('@/views/cam-users/DataListView.vue'),
          meta: {
            breadcrumb:  i18n.t('menu.users.meta.breadcrumb'),
            pageTitle:  i18n.t('menu.users.meta.pageTitle'),
            rule:  i18n.t('menu.users.meta.rule')
          }
        },
        {
          path:  i18n.t('menu.incidents.url'),
          name:  i18n.t('menu.incidents.name'),
          component: () => import('@/views/incidents/Incidents.vue'),
          meta: {
            breadcrumb:  i18n.t('menu.incidents.meta.breadcrumb'),
            pageTitle:  i18n.t('menu.incidents.meta.pageTitle'),
            rule:  i18n.t('menu.incidents.meta.rule')
          }
        },
        {
          path: '/tickets',
          name: 'Tickets',
          component: () => import('./views/tickets/ListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Tickets', active: true }
            ],
            pageTitle: 'Tickets',
            rule: 'manager'
          }
        },
        {
          path: '/ticket/:ticketId',
          name:'Ticket Profile',
          component: () => import('@/views/tickets/Profile.vue'),
          meta: {
            breadcrumb:[
              {
                'title': 'Home',
                'url': '/'
              },
              {
                'title': 'Tickets',
                'url': '/tickets'
              },
              {
                'title': 'View',
                'active': true
              }
            ],
            pageTitle:'Ticket View',
            rule: 'manager'
          }
        },
        {
          path: '/locations',
          name: 'Locations',
          component: () => import('./views/locations/ListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Locations', active: true }
            ],
            pageTitle: 'Locations',
            rule: 'manager'
          }
        },
        {
          path: '/locations/:locationId',
          name:'Location Profile',
          component: () => import('@/views/locations/profile.vue'),
          meta: {
            breadcrumb:[
              {
                'title': 'Home',
                'url': '/'
              },
              {
                'title': 'Locations',
                'url': '/locations'
              },
              {
                'title': 'View',
                'active': true
              }
            ],
            pageTitle:'Location View',
            rule: 'manager'
          }
        },
        {
          path: '/programs',
          name: 'Programs',
          component: () => import('./views/programs/programsListView'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Programs', active: true }
            ],
            pageTitle: 'Programs',
            rule: 'manager'
          }
        },
        {
          path: '/cameras',
          name: 'Cameras',
          component: () => import('./views/cameras/ListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Cameras', active: true }
            ],
            pageTitle: 'Cameras',
            rule: 'manager'
          }

        },
        {
          path: '/schedules',
          name: 'Schedules',
          component: () => import('./views/schedules/ListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Schedules', active: true }
            ],
            pageTitle: 'Schedules',
            rule: 'manager'
          }
        },
        {
          path: '/theme-customizer',
          name: 'Theme Customizer',
          component: () => import('./views/Settings/ThemeCustomizer'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Theme Customizer', active: true }
            ],
            pageTitle: 'Theme Customizer',
            rule: 'admin'
          }
        },
        {
          path: '/onboarding',
          name: 'Onboarding',
          component: () => import('./views/Settings/OnBoarding'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Onboarding', active: true }
            ],
            pageTitle: 'Onboarding',
            rule: 'kvsupport'
          }
        },
        {
          path: '/school_profile',
          name: 'School Profile',
          component: () => import('./views/Settings/School'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'School Profile', active: true }
            ],
            pageTitle: 'School Profile',
            rule: 'admin'
          }
        },
        {
          path: '/images',
          name: 'Images',
          component: () => import('./views/images/imagesListView'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Images', active: true }
            ],
            pageTitle: 'Images',
            rule: 'manager'
          }
        },
        {
          path: '/folder/:folder',
          name: 'folder',
          component: () => import('./views/images/FolderImageView'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Images', url: '/images' },
              { title: 'Folder', active: true }
            ],
            pageTitle: 'Images',
            rule: 'admin'
          }
        },
        {
          path: '/announcements',
          name: 'Announcements',
          component: () => import('./views/messagings/Announcement.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Announcements', active: true }
            ],
            pageTitle: 'Announcements',
            rule: 'teacher'
          }
        },
        {
          path: '/alerts',
          name: 'alerts',
          component: () => import('./views/chat/Chat.vue'),
          meta: {
            rule: 'user',
            no_scroll: true
          }
        },
        {
          path: '/alerts-log',
          name: 'Alerts Log',
          component: () => import('./views/messagings/Alert.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Alert Logs', active: true }
            ],
            pageTitle: 'Alerts Log',
            rule: 'teacher'
          }
        },
        {
          path: '/instant_message',
          name: 'Instant Message',
          component: () => import('./views/messagings/InstantMessage.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Instant Message', active: true }
            ],
            pageTitle: 'Instant Message',
            rule: 'teacher'
          }
        },
        {
          path:  i18n.t('menu.teachers.url'),
          name:  i18n.t('menu.teachers.name'),
          component: () => import('@/views/teachers/DataListView.vue'),
          meta: {
            breadcrumb:  i18n.t('menu.teachers.meta.breadcrumb'),
            pageTitle:  i18n.t('menu.teachers.meta.pageTitle'),
            rule:  i18n.t('menu.teachers.meta.rule')
          }
        },
        {
          path: '/managers',
          name: 'managers',
          component: () => import('@/views/managers/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Managers', active: true }
            ],
            pageTitle: 'Managers',
            rule: 'manager'
          }
        },
        {
          path: '/team',
          name: 'team',
          component: () => import('@/views/team/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Team', active: true }
            ],
            pageTitle: 'Team',
            rule: 'center'
          }
        },
        {
          path: i18n.t('route.student_profile.url'),
          name:i18n.t('route.student_profile.name'),
          component: () => import('@/views/students/profile.vue'),
          meta: {
            breadcrumb:i18n.t('route.student_profile.meta.breadcrumb'),
            pageTitle:i18n.t('route.student_profile.meta.pageTitle'),
            rule: i18n.t('route.student_profile.meta.rule')
          }
        },
        {
          path: i18n.t('route.teacher_student_profile.url'),
          name:i18n.t('route.teacher_student_profile.name'),
          component: () => import('@/views/teacher-students/profile.vue'),
          meta: {
            breadcrumb:i18n.t('route.teacher_student_profile.meta.breadcrumb'),
            pageTitle:i18n.t('route.teacher_student_profile.meta.pageTitle'),
            rule: i18n.t('route.teacher_student_profile.meta.rule')
          }
        },
        {
          path: i18n.t('route.user_profile.url'),
          name: i18n.t('route.user_profile.name'),
          component: () => import('@/views/cam-users/profile.vue'),
          meta: {
            breadcrumb:i18n.t('route.user_profile.meta.breadcrumb'),
            pageTitle: i18n.t('route.user_profile.meta.pageTitle'),
            rule: i18n.t('route.user_profile.meta.rule')
          }
        },
        {
          path: '/student/cameras/:camId',
          name: 'app-camera-view',
          component: () => import('@/views/students/camprofile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Students', url:'/students' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Camera View',
            rule: 'user'
          }
        },
        {
          path: '/incident/:id',
          name: 'view-incident',
          component: () => import('@/views/incidents/ViewIncident.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Incidents', url:'/incidents' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Incident View',
            rule: 'manager'
          }
        },
        // {
        //   path: '/students/cameras/:camId',
        //   name: 'camera-view',
        //   component: () => import('@/views/user-students/camprofile.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Students', url:'/user/students' },
        //       { title: 'View', active: true }
        //     ],
        //     pageTitle: 'Camera View',
        //     rule: 'user'
        //   }
        // },
        {
          path: i18n.t('route.user_camera.url'),
          name:i18n.t('route.user_camera.name'),
          component: () => import('@/views/user-students/camprofile.vue'),
          meta: {
            breadcrumb:i18n.t('route.user_camera.meta.breadcrumb'),
            pageTitle:i18n.t('route.user_camera.meta.pageTitle'),
            rule: i18n.t('route.user_camera.meta.rule')
          }
        },
        {
          path: '/students/cameras/:camId',
          name: 'camera-view',
          component: () => import('@/views/user-students/camprofile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Students', url:'/user/students' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Camera View',
            rule: 'user'
          }
        },

        {
          path: i18n.t('menu.admins.url'),
          name: i18n.t('menu.admins.name'),
          component: () => import('@/views/admins/DataListView.vue'),
          meta: {
            breadcrumb: i18n.t('menu.admins.meta.breadcrumb'),
            pageTitle: i18n.t('menu.admins.meta.pageTitle'),
            rule: i18n.t('menu.admins.meta.rule')
          }
        },
        {
          path: i18n.t('menu.users_profile.url'),
          name: i18n.t('menu.users_profile.name'),
          component: () => import('@/views/cam-users/ViewUserProfile.vue'),
          meta: {
            breadcrumb:i18n.t('menu.users_profile.meta.breadcrumb'),
            pageTitle: i18n.t('menu.users_profile.meta.pageTitle'),
            rule: i18n.t('menu.users_profile.meta.rule')
          }
        },
        {
          path: i18n.t('menu.user_student_cameras.url'),
          name:i18n.t('menu.user_student_cameras.name'),
          component: () => import('@/views/user-students/DataCamList.vue'),
          meta: {
            // breadcrumb:i18n.t('menu.user_student_cameras.meta.breadcrumb'),
            pageTitle:i18n.t('menu.user_student_cameras.meta.pageTitle'),
            rule: i18n.t('menu.user_student_cameras.meta.rule')
          }
        },

        {
          path: '/dailylogins',
          name: 'Daily Login',
          component: () => import('./views/reports/DailyLogin.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Daily Logins', active: true }
            ],
            pageTitle: 'Daily Logins',
            rule: 'manager'
          }
        },
        {
          path: '/dailywatchtime',
          name: 'Daily Watch Time',
          component: () => import('./views/reports/DailyWatch.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Daily Watch Time', active: true }
            ],
            pageTitle: 'Daily Watch Time',
            rule: 'manager'
          }
        },
        {
          path: '/log-report',
          name: 'Log Report',
          component: () => import('./views/reports/LogReportView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Log Report', active: true }
            ],
            pageTitle: 'Log Report',
            rule: 'manager'
          }
        },
        {
          path: '/newsletters',
          name: 'Newsletters',
          component: () => import('@/views/newsletters/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Newsletters', active: true }
            ],
            pageTitle: 'Newsletters',
            rule: 'manager'
          }
        },
        {
          path: '/newsletters/:tempId',
          name: 'newsletters-temp',
          component: () => import('@/views/newsletters/template1.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Newsletters', url:'/newsletters' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Newsletters',
            rule: 'manager'
          }
        },
        {
          path: '/newsletter/new',
          name: 'new-newsletter',
          component: () => import('@/views/newsletters/NewTemplate.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Newsletters', url:'/newsletters' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Newsletters',
            rule: 'manager'
          }
        },
        {
          path: '/templates',
          name: 'Templates',
          component: () => import('@/views/newsletters/DataListTemp.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Newsletters Templates', active: true }
            ],
            pageTitle: 'Newsletters Templates',
            rule: 'admin'
          }
        },
        {
          path: '/newsletters/:is_temp/:tempId',
          name: 'newsletters-templates',
          component: () => import('@/views/newsletters/template1.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Newsletters Templates', url:'/templates' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Newsletters Templates',
            rule: 'admin'
          }
        },
        {
          path: '/newsletter/:is_temp/new',
          name: 'new-newsletter-template',
          component: () => import('@/views/newsletters/NewTemplate.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Newsletters Templates', url:'/templates' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Newsletters Templates',
            rule: 'admin'
          }
        },
        {
          path: '/permissions',
          name: 'permissions',
          component: () => import('@/views/permissions/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Permissions Management', url:'/permissions', active: true }
              // { title: 'View', active: true }
            ],
            pageTitle: 'Permissions Management',
            rule: 'admin'
          }
        },
        {
          path: '/grapesjs/:page?',
          name: 'grapes-js',
          component: () => import('@/views/grapesjs/grapes.vue'),
          meta: {
            pageTitle: ' ',
            rule: 'admin',
            // breadcrumb: [
            //   {
            //     text: 'Second Page',
            //     active: true,
            //   },
            // ],
          },
        },
        {
          path: '/sites',
          name: 'sites',
          component: () => import('@/views/grapesjs/sites.vue'),
          meta: {
            pageTitle: ' ',
            rule: 'admin',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sites', url:'/sites', active: true }
            ],
            pageTitle: 'Sites',
          },
        },
        {
          path: '/site/:siteName/:sitePage',
          name:'site',
          component: () => import('@/views/grapesjs/site.vue'),
          meta: {
            // breadcrumb:[
            //   {
            //     'title': 'Home',
            //     'url': '/'
            //   },
            //   {
            //     'title': 'Locations',
            //     'url': '/locations'
            //   },
            //   {
            //     'title': 'View',
            //     'active': true
            //   }
            // ],
            pageTitle:' ',
            rule: 'admin'
          }
        },
        {
          path: '/food/:siteName',
          name:'food',
          component: () => import('@/views/grapesjs/foodMenu/foodMenu.vue'),
          meta: {
            breadcrumb:[
              {
                'title': 'Home',
                'url': '/sites'
              },
              {
                'title': 'View Menu',
                'active': true
              }
            ],
            pageTitle:'View Menu',
            rule: 'admin'
          }
        },
        {
          path: '/draft',
          name: 'grapes-js',
          component: () => import('@/views/grapesjs/draft.vue'),
          meta: {
            pageTitle: ' ',
            rule: 'admin',
            // breadcrumb: [
            //   {
            //     text: 'Second Page',
            //     active: true,
            //   },
            // ],
          },
        },
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: 'login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'register/:code?',
          name: 'page-register',
          component: () => import('@/views/pages/Register'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'email-confirmation',
          name: 'email-confirmation',
          component: () => import('@/views/pages/EmailConfirmationPage'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'verify-email/:pin_time?',
          name: 'verify-email',
          component: () => import('@/views/pages/VerifyEmailPage'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'viue/:pin_time',
          name: 'viue',
          component: () => import('@/views/pages/VerifyInvitedUserEmail'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'viup/:pin_time',
          name: 'viup',
          component: () => import('@/views/pages/VerifyInvitedUserPhone'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'password/reset/:token?',
          name: 'reset-password',
          component: () => import('@/views/pages/ResetPassword'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'forgot-password',
          name: 'forgot-password',
          component: () => import('@/views/pages/ForgotPassword'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'resend-confirmation-email',
          name: 'resend-confirmation-email',
          component: () => import('@/views/pages/ResendTokenEmail'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'guest'
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
